import { render } from "./OnboardingImport.vue?vue&type=template&id=63a04d30"
import script from "./OnboardingImport.vue?vue&type=script&lang=js"
export * from "./OnboardingImport.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__